// extracted by mini-css-extract-plugin
export default {"countComponent":"oRA+8q4-nqeQWzu8h-jTiA=="};